module.exports = __webpack_public_path__ + "static/media/layout-Program-MEMO-ID-TEAM-GUIDE-3.368dfd57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fina-vaterpolo/layout-Program-MEMO-ID-TEAM-GUIDE-3.jpg
// module id = 415
// module chunks = 0